function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import { each } from 'meteora';
/* --------------------------------------------------
Hover Image Class
-------------------------------------------------- */
// A new class to handle hover images

var CaseStudyHover = /*#__PURE__*/function () {
  function CaseStudyHover(canvas) {
    _classCallCheck(this, CaseStudyHover);

    this.canvas = canvas;
    this.parent = this.canvas.parentNode;
    this.ctx = canvas.getContext('2d');
    this.image = null; // The dpr

    this.dpr = window.devicePixelRatio || 1; // This will become the coordinates of the hover image

    this.mouse = {
      x: 0,
      y: 0
    }; // The position w
  }

  _createClass(CaseStudyHover, [{
    key: "init",
    value: function init() {
      var _this = this;

      // We will use this canvas to scale the image for performance
      this.buffer = {};
      this.buffer.canvas = document.createElement('canvas');
      this.buffer.ctx = this.buffer.canvas.getContext('2d');
      this.buffer.canvas.width = this.image.width * this.dpr;
      this.buffer.canvas.height = this.image.height * this.dpr;
      this.buffer.ctx.drawImage(this.image, 0, 0, this.image.width * this.dpr, this.image.height * this.dpr); // We will use this to center the image at the mouse position

      this.position = {
        x: -(this.image.width * this.dpr * .5),
        y: -(this.image.height * this.dpr * .5)
      }; // Event listeners

      this.parent.addEventListener('mousemove', function (e) {
        _this.mouse.x = (e.offsetX + e.srcElement.offsetLeft) * _this.dpr;
        _this.mouse.y = (e.offsetY + e.srcElement.offsetTop) * _this.dpr;

        _this.draw();
      }); // The resize observe

      this.resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          return _this.resize();
        });
      }); // Start observing the canvas

      this.resizeObserver.observe(this.canvas); // Initialise the canvas size

      this.resize();
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // Create a new image
      this.image = new Image(); // When the image loads, draw it

      this.image.addEventListener('load', function () {
        return _this2.init();
      }); // Set the source

      this.image.src = src; // Remove the load function as it has already been called

      this.load = function () {
        return console.log('The load function has already been called!');
      };
    }
  }, {
    key: "resize",
    value: function resize() {
      this.canvas.width = this.canvas.clientWidth * this.dpr;
      this.canvas.height = this.canvas.clientHeight * this.dpr;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        // Clear the canvas
        _this3.ctx.clearRect(0, 0, _this3.canvas.width, _this3.canvas.height); // Draw the image at the mouse position rotated 45deg


        _this3.ctx.save();

        _this3.ctx.translate(_this3.mouse.x, _this3.mouse.y);

        _this3.ctx.rotate(35 * Math.PI / 180);

        _this3.ctx.drawImage(_this3.buffer.canvas, _this3.position.x, _this3.position.y);

        _this3.ctx.restore();
      });
    }
  }]);

  return CaseStudyHover;
}();
/* --------------------------------------------------
Image Text
-------------------------------------------------- */
// Loop through all the image text blocks


each('.js-case-study', function (block) {
  // Find the canvas element if there is one
  var canvas = block.querySelector('canvas') || false;

  if (canvas) {
    var HoverImage = new CaseStudyHover(canvas);
    HoverImage.load(canvas.getAttribute('data-image'));
  }
});